import { useApolloClient } from "@apollo/client";
import { getDataOrNull } from "@msys/common";
import Avatar from "@mui/material/Avatar";
import { getInitials } from "../../commons/Avatar.js";
import {
  FilterChipGroup,
  FilterChipGroupProps,
} from "../../commons/filters/FilterChip.js";
import { getPersonLabel } from "../users/helpers.js";
import { useFilterOrganisationMembersChipsQuery } from "./FilterOrganisationMembersChips.generated.js";

interface Props extends Omit<FilterChipGroupProps<string>, "getValueLabel"> {}

export function OrganisationMembersFilterChips(props: Props) {
  const client = useApolloClient();
  const query = useFilterOrganisationMembersChipsQuery({
    client,
    fetchPolicy: "network-only",
    variables: {
      userIds: props.values
        ? Array.isArray(props.values)
          ? props.values
          : [props.values]
        : [],
    },
  });
  const activeMembers =
    getDataOrNull(
      (query?.data ?? query?.previousData)?.organisationMemberships
    )?.edges.map(edge => edge.node) ?? [];

  return (
    <FilterChipGroup
      {...props}
      getValueLabel={value => {
        const member = activeMembers.find(u => u.id === value);
        if (member) return getPersonLabel(member, false);
        return "-";
      }}
      getAvatar={value => {
        const member = activeMembers.find(u => u.id === value);
        if (member) {
          const initials = getInitials(member.firstname, member.familyname);

          return <Avatar src={member.avatar?.url}>{initials}</Avatar>;
        }
      }}
    />
  );
}
